export enum AvatarType {
  IMG = "img",
  ICON = "icon",
  TEXT = "text"
}

export enum AvatarSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large"
}
